import { FirestoreDataConverter } from "firebase/firestore";
import { Coordinates } from "@/models";

export interface SearchLogData {
    /**
     * User ID if authenticated; session ID if not authenticated.
     */
    uid: string;

    userOrg?: string;

    condition?: string;

    studyTypes?: string[];

    location?: Coordinates;

    distance?: number | "all";

    age?: string;

    gender?: string;

    isAnonymous: boolean;

    createdAt: Date;

    sessionId: string;
}

class SearchLog implements SearchLogData {
    readonly uid: string;

    readonly userOrg?: string;

    readonly condition?: string;

    readonly studyTypes?: string[];

    readonly distance?: number | "all";

    readonly age?: string;

    readonly gender?: string;

    readonly location?: Coordinates;

    readonly isAnonymous: boolean;

    readonly createdAt: Date;

    readonly sessionId: string;

    constructor(data: SearchLogData) {
        this.uid = data.uid;
        this.userOrg = data.userOrg;
        this.condition = data.condition;
        this.studyTypes = data.studyTypes;
        this.distance = data.distance;
        this.location = data.location;
        this.createdAt = data.createdAt;
        this.age = data.age;
        this.gender = data.gender;
        this.isAnonymous = data.isAnonymous;
        this.sessionId = data.sessionId;
    }
}

export const searchLogDataConverter: FirestoreDataConverter<SearchLog> = {
    toFirestore(data: SearchLog): SearchLogData {
        const obj: SearchLogData = {
            uid: data.uid,
            userOrg: data.userOrg,
            isAnonymous: data.isAnonymous,
            createdAt: data.createdAt,
            sessionId: data.sessionId,
        };
        // Only add optional fields with data
        if (data.condition) obj.condition = data.condition;
        if (data.studyTypes) obj.studyTypes = data.studyTypes;
        if (data.distance) obj.distance = data.distance;
        if (data.age) obj.age = data.age;
        if (data.gender) obj.gender = data.gender;
        if (data.location) obj.location = data.location;

        return obj;
    },
    fromFirestore(snapshot, options): SearchLog {
        const data = snapshot.data(options);
        return new SearchLog({
            uid: data.uid,
            userOrg: data.userOrg,
            location: data.location,
            condition: data.condition,
            studyTypes: data.studyType,
            distance: data.distance,
            createdAt: data.createdAt,
            age: data.age,
            gender: data.gender,
            isAnonymous: data.isAnonymous,
            sessionId: data.sessionId,
        });
    },
};

export default SearchLog;
